import { Box, ListItemButton } from "@mui/material";
import { Typography } from "@platform/design-system";

import type { Carrier } from "../types";

interface CarrierListItemProps {
  carrier: Carrier;
  selected: boolean;
  onSelect: (carrier: Carrier) => void;
}

export const CarrierListItem = ({
  carrier,
  selected,
  onSelect,
}: CarrierListItemProps): React.JSX.Element => (
  <ListItemButton
    data-testid={`carrier-list-item-${carrier.id}`}
    selected={selected}
    onClick={() => onSelect(carrier)}
  >
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      width="100%"
    >
      <Typography variant="body-large">{carrier.name}</Typography>
      <Typography variant="body-medium" color="textSecondary">
        {carrier.repsCount} reps
      </Typography>
    </Box>
  </ListItemButton>
);
